import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '60vh', padding: '2rem',
          textAlign: 'center', color: 'var(--white)',
        }}>
          <div style={{
            width: 64, height: 64, borderRadius: 16, display: 'flex',
            alignItems: 'center', justifyContent: 'center', marginBottom: '1rem',
            background: 'rgba(214,60,42,.15)', fontSize: '1.5rem', fontWeight: 700,
          }}>
            !
          </div>
          <h2 style={{ fontSize: '1.1rem', fontWeight: 700, marginBottom: '.5rem' }}>
            Algo ha ido mal
          </h2>
          <p style={{ fontSize: '.9rem', color: 'var(--mid)', maxWidth: 400, marginBottom: '1.5rem' }}>
            Ha ocurrido un error inesperado. Prueba a recargar la pagina.
          </p>
          <button
            className="btn btn-primary"
            onClick={() => {
              this.setState({ hasError: false, error: null });
              window.location.reload();
            }}
          >
            Recargar pagina
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <pre style={{
              marginTop: '1.5rem', padding: '1rem', background: 'rgba(255,255,255,.05)',
              borderRadius: 8, fontSize: '.75rem', color: '#ff7a6a', maxWidth: 500,
              overflow: 'auto', textAlign: 'left',
            }}>
              {this.state.error.message}
              {'\n'}
              {this.state.error.stack}
            </pre>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}
